import React, { useEffect, useState } from "react";

import { Box, CircularProgress, Typography } from "@mui/material";
import { fundService } from "./services/fundService";
import { useAllFundsQuery } from "./hooks/useFunds";

interface Props {
  children: React.ReactNode;
}

export const SystemDataInitializer: React.FC<Props> = ({ children }) => {
    const { isLoading, isSuccess } = useAllFundsQuery();
    const [isReady, setIsReady] = useState(false);
  
    useEffect(() => {
      if (isSuccess) {
        setIsReady(true); // המידע כבר קיים והמפה נבנתה אוטומטית מתוך ה-service
      }
    }, [isSuccess]);
  
    if (isLoading || !isReady) {
      return (
        <Box
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            טוען מידע קרנות עדכני...
          </Typography>
        </Box>
      );
    }
  
    return <>{children}</>;
  };